// src/router/index.ts
import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'
import { useAuthStore } from '@/admin/stores/Auth/auth'
import NProgress from 'nprogress'

function has(mask: number, perm: number) { return (mask & perm) === perm }

const router = createRouter({
  history: createWebHistory(),   // or createWebHashHistory()
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

/** Ensure html.admin is set BEFORE the route renders */
router.beforeResolve((to) => {
  if (typeof document !== 'undefined') {
    const isAdmin = to.path.startsWith('/admin')
    document.documentElement.classList.toggle('admin', isAdmin)
  }
})

router.beforeEach(async (to) => {
  NProgress?.start?.()

  const auth = useAuthStore()

  if (!auth.hydrated) {
    try { await auth.initFromStorage() } catch {}
  }

  const authed = auth.isAuthenticated
  const requiresAuth = to.matched.some(r => r.meta?.requiresAuth)
  const guestOnly    = to.matched.some(r => r.meta?.guestOnly)

  if (guestOnly && authed) return { name: 'All-Post' }
  if (requiresAuth && !authed) return { name: 'login', query: { redirect: to.fullPath } }

  const permTarget = [...to.matched].reverse().find(r =>
    typeof r.meta?.page === 'string' && typeof r.meta?.perm === 'number'
  )
  if (permTarget) {
    if (authed && (!auth.perms || Object.keys(auth.perms).length === 0)) {
      try { await auth.refreshPermissions() } catch {
        await auth.logout()
        return { name: 'login', query: { redirect: to.fullPath } }
      }
    }
    const page = permTarget.meta!.page as string
    const perm = permTarget.meta!.perm as number
    const mask = auth.perms?.[page] ?? 0
    if (!has(mask, perm)) return { name: 'forbidden' }
  }

  return true
})

router.afterEach(() => {
  NProgress?.done?.()
})

// scrollBehavior(to) {
//   if (!to.hash) return { top: 0 }
//   return new Promise(resolve => {
//     requestAnimationFrame(() => {
//       const el = document.querySelector(to.hash)
//       if (el) {
//         el.scrollIntoView({ behavior: "smooth", block: "center" })
//         return resolve(false)
//       }
//       resolve({ top: 0 })
//     })
//   })
// }


export default router
